import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2da3af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-size-14" }
const _hoisted_2 = { class: "w-full d-flex items-center justify-content-between" }
const _hoisted_3 = { class: "beginner-order-label" }

import { computed } from "vue";
import { SlimOrder } from "@/types/order/Order";
import BeginnerTag from "@/components/atoms/other/BeginnerTag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BeginnerOrderLabel',
  props: {
    order: {},
    orderService: {}
  },
  setup(__props: any) {

const props = __props;



const isWelcomeNoExpInNursingCare = computed(() => {
  // 1 = 'welcome_no_exp_in_nursing_care'
  return props.order.recommendationPoints.includes(1);
});

const isWelcomeCaitechBeginners = computed(() => {
  // 2 = 'welcome_caitech_beginners'
  return props.order.recommendationPoints.includes(2);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (isWelcomeNoExpInNursingCare.value)
          ? (_openBlock(), _createBlock(BeginnerTag, {
              key: 0,
              label: "介護未経験者歓迎",
              class: "text-primary-dark bg-welcome-no-exp-in-nursing-care"
            }))
          : _createCommentVNode("", true),
        _createTextVNode(),
        (isWelcomeCaitechBeginners.value)
          ? (_openBlock(), _createBlock(BeginnerTag, {
              key: 1,
              label: "カイテク初心者歓迎",
              class: "text-primary-dark bg-welcome-caitech-beginners"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})